import { render, staticRenderFns } from "./Privilegies.vue?vue&type=template&id=6c2f88c7&scoped=true"
import script from "./Privilegies.vue?vue&type=script&lang=js"
export * from "./Privilegies.vue?vue&type=script&lang=js"
import style0 from "./Privilegies.vue?vue&type=style&index=0&id=6c2f88c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2f88c7",
  null
  
)

export default component.exports